<template>
  <div class="PrepareForFlightText container_w dis_bo" style="padding-top: 96px;">
    <div style="text-decoration: underline; font-family: 'times new roman'; font-size: 18px;margin-bottom: 20px;">{{fileTitle}}</div>
    <div v-html="collapseHtml"></div>
  </div>
</template>

<script>
export default {
  name: "PrepareForFlightText",
  data() {
    return {
      fileTitle: "",
      collapseHtml: ''
    };
  },
  props: {},
  watch: {},
  methods: {
    getFileTextHtml(url) {
      this.$Ajax.get(url).then((response) => {
        this.collapseHtml = response.data
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  filters: {},
  computed: {},
  created() {
    this.getFileTextHtml(this.$route.query.filetext)
    this.fileTitle = this.$route.query.filetitle
  },
  mounted() {},
  destroyed() {}
};
</script>

<style scoped lang="less">

</style>